import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ContactCTA = () => {
  const navigate = useNavigate();
  const springTransition = { type: "spring", stiffness: 100, damping: 20 };

  // Fonction pour scroller vers le CTA principal
  const scrollToCTA = () => {
    const ctaElement = document.getElementById('ctaOsint');
    if (ctaElement) {
      ctaElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="w-full bg-[#f0f7ff] py-20 px-6 flex justify-center items-center font-inter">
      <div className="max-w-4xl w-full text-center">
        
        {/* Main Title */}
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={springTransition}
          className="text-[28px] md:text-[36px] font-black text-[#0f172a] mb-6 tracking-tight"
        >
          Prêt à sécuriser votre organisation ?
        </motion.h2>

        {/* Description Text */}
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ ...springTransition, delay: 0.1 }}
          className="text-[#64748b] text-base md:text-lg font-medium mb-10 max-w-2xl mx-auto leading-relaxed"
        >
          Nos experts en cybersécurité vous accompagnent dans votre stratégie OSINT pour transformer l'information en protection.
        </motion.p>

        {/* Button Group */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ ...springTransition, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          {/* Primary Action Button */}
          <motion.button
            onClick={() => navigate('/rdv')}
            whileHover={{ y: -4, boxShadow: "0 12px 20px -8px rgba(59, 130, 246, 0.5)" }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center gap-2 bg-[#1d88f0] text-white px-8 py-4 rounded-xl font-bold text-sm shadow-lg shadow-blue-500/20 transition-all w-full sm:w-auto justify-center"
          >
            <Calendar size={18} />
            Prendre rendez-vous
          </motion.button>

          
          <motion.button
            onClick={scrollToCTA}
            whileHover={{ y: -4, backgroundColor: "#ffffff" }}
            whileTap={{ scale: 0.98 }}
            className="bg-[#eef5ff] text-[#0f172a] border border-slate-200 px-8 py-4 rounded-xl font-bold text-sm transition-all w-full sm:w-auto justify-center cursor-pointer"
          >
            Découvrir nos services
          </motion.button>
        </motion.div>

      </div>
    </section>
  );
};

export default ContactCTA;
